// extracted by mini-css-extract-plugin
module.exports = {"pagination_wrapper":"pagination_pagination_wrapper__EZ8Eh","shwing_num":"pagination_shwing_num___10Qi"};